import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SearchPage.css'; // Import styles


export default function SearchPage() {
  const [term, setTerm] = useState('');
  const [page, setPage] = useState(1);
  const [results, setResults] = useState([]);
  const [lastSearchTerm, setLastSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) navigate('/login');
  }, [navigate]);

  useEffect(() => {
    if (lastSearchTerm) {
      search(lastSearchTerm, page);
    }
  }, [page]);

  const search = async (searchTerm, pageNum) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(
        `https://x464cmen4h.execute-api.us-west-2.amazonaws.com/prod/search`,
        {
          params: { term: searchTerm, page: pageNum },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setResults(res.data.FilteredResults || []);
    } catch (err) {
        if (err.response && err.response.status === 401) {
            alert('Session expired. Please log in again.');
            localStorage.removeItem('token');
            navigate('/login');
          } else {
            alert('Search failed or unauthorized');
          }
    }
  };

  const handleSearch = () => {
    if (!term.trim()) return;
    setPage(1);
    setLastSearchTerm(term);
    search(term, 1);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  const handleNext = () => {
    setPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  return (
    <div className="container">
      <h2>🏠 Property Search</h2>

      <div className="search-bar">
        <input
          placeholder="Search Term"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      <div className="results">
        <h3>Results (Page {page})</h3>

        {results.length === 0 ? (
          <p>No results found.</p>
        ) : (
          <div className="results-list">
            {results.map((item, i) => (
              <div key={i} className="result-row">
                <div><strong>Owner:</strong> {item.Ownership}</div>
                <div><strong>Address:</strong> {item.SitusAddress}</div>
                <div><strong>Zip:</strong> {item.SitusZip}</div>
                <div><strong>City:</strong> {item.SitusCity}</div>
                <div><strong>Type:</strong> {item.PropertyType}</div>
              </div>
            ))}
          </div>
        )}

        <div className="pagination">
        {page > 1 && (
            <button onClick={handlePrev} className="pagination-button">
            ⬅ Prev
            </button>
        )}
        {results.length >= 5 && (
            <button onClick={handleNext} className="pagination-button">
            Next ➡
            </button>
        )}
        </div>

      </div>
    </div>
  );
}
